import { createContext, useContext } from "react";

export const OrganizationContext = createContext({
  organizations: [],
  selectedOrgId: null,
  selectedOrganization: null,
  organizationType: "automotive",
  isAutomotive: true,
  appName: "ASC TuneUp",
  customAuditRulesEnabled: false,
  ascEventUsageEnabled: false,
  setSelectedOrgId: () => {},
  refreshOrganizations: () => {},
});

export const useOrganization = () => useContext(OrganizationContext);
